class HomePageOfferingDTO {
    constructor(primary, seco, ter) {
        this.primary = primary;
        this.secondary = seco;
        this.tertiary = ter;
    }
}
export default HomePageOfferingDTO;
